module.exports = __webpack_public_path__ + "media/images/cc-50a14e63903e0954c110d14adf5ef2ed.svg";